
export class CategoryColor {

    fallback = "gray";

    static array_colors = {
        tech:"#D2227B",
        economy:"#E5CB52",
        education:"#EF767E",
        lifestyle:"#43BDCC",
        startup:"#39CD62",
        impact:"#7F8CD1",
        agenda:"#7F8CD1",
        bandi:"#7F8CD1",
        my:"#7F8CD1",
        'unstoppable-women': "7F8CD1",
        // default:"#7F8CD1",
        life: "#7F8CD1",
        valoreresponsabile: "#7F8CD1",
        smartmoney: "#7F8CD1",
        option: "#7F8CD1",
        about_us: "#7F8CD1",
        investor: "#7F8CD1",
        unstoppablewomen: "#7F8CD1",

        menu_desk_life:"#7F8CD1",
        menu_desk_valoreresponsabile:"#7F8CD1",
        menu_desk_smartmoney: "#7F8CD1",
        menu_desk_about_us: "#7F8CD1",
        menu_desk_investor: "#7F8CD1",
        menu_desk_unstoppablewomen: "#7F8CD1",

        default:"#7F8CD1",
    }

    constructor(category) {
        this.category = category.toLowerCase().replace(/\//g, '');;
    }

    get arrayColors() {
        return CategoryColor.array_colors;
    }

    get color() {
        if (this.category) {
            return CategoryColor.array_colors[this.category] ?
                CategoryColor.array_colors[this.category] : this.fallback;
        } else {
            return this.fallback;
        }
    }
};
